exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal-header{font-size:22px!important;font-weight:400;line-height:32px!important;letter-spacing:normal!important}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/CantAccess.vue"],"names":[],"mappings":"AACA,cACE,yBAA2B,AAC3B,gBAAiB,AACjB,2BAA6B,AAC7B,+BAAkC,CACnC","file":"CantAccess.vue","sourcesContent":["\n.modal-header{\n  font-size: 22px !important;\n  font-weight: 400;\n  line-height: 32px !important;\n  letter-spacing: normal !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11a11e47","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/hotsite/CantAccess.vue
// module id = 604
// module chunks = 23